module.exports = __webpack_public_path__ + "img/belt2.e472239a.jpg";